// extracted by mini-css-extract-plugin
export default {"inputLabel":"NumberFieldSpinner_inputLabel__3kpcL"};